export default __webpack_public_path__ + "static/3-ae8fb752e3c5e05bda92d9bb9dbf8345.png";